import {
	Error,
	FetchTokenSupportingPlatformsData,
	FetchTokenSupportingPlatformsParams
} from '../../../models/__generated/data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class TokenSupportingPlatformApi<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description Endpoint to list token supporting platforms
	 *
	 * @tags TokenSupportingPlatform, Partner
	 * @name FetchTokenSupportingPlatforms
	 * @summary Search token supporting platforms
	 * @request GET:/api/acl-service/v1/front/token-supporting-platforms
	 * @secure
	 * @response `200` `FetchTokenSupportingPlatformsData` Successfully get token supporting platform list ([simple paginationMode enabled](https://bookstack.chiliz.com/books/development-guides/page/pagination))
	 * @response `400` `Error`
	 */
	fetchTokenSupportingPlatforms = (query: FetchTokenSupportingPlatformsParams, params: RequestParams = {}) =>
		this.http.request<FetchTokenSupportingPlatformsData, Error>({
			path: `/api/acl-service/v1/front/token-supporting-platforms`,
			method: 'GET',
			query: query,
			secure: true,
			...params
		});
}
